module.exports = __webpack_public_path__ + "img/me.df0c6f52.jpg";